import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Duplicate from '@/images/Duplicate.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { duplicateElements } from '../../actions/Duplicate';

interface Props {
    closeMenu: () => void;
}

export const DuplicateMenuItem = ({ closeMenu }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        closeMenu();
        duplicateElements(store, selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Duplicate} text="Duplicate" />;
};
